export default __webpack_public_path__ + "static/media/element_65.37b834be.webp";